/**
 * 描述：popover小浮框
 * 日期：2017-9-13
 * 作者：Bai.zhiming
 */
angular.module("popoverModule", [])
    .directive("trsPopover", ["$compile", "$timeout", function($compile, $timeout) {
        return {
            replace: false,
            restrict: "A",
            transclude: false,
            scope: {
                list: "=",
                callback: "&",
                selectedItem: "="
            },
            link: function(scope, $elem, $attr) {
                initStatus();
                initData();
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        listShow: false,
                    };
                    scope.data = {};
                    bindClick();
                    appendPopover();
                    bindBody();
                }
                /**
                 * [bindClick description] 绑定点击事件
                 * @return {[type]} [description]
                 */
                function bindClick() {
                    $elem.bind("click", function() {
                        $timeout(function() {
                            scope.status.listShow = !scope.status.listShow;
                        });
                    });
                }
                /**
                 * [bindBody description]给body绑定bind事件
                 * @return {[type]} [description]
                 */
                function bindBody() {
                    $("body").click(function(event) {
                        if (event.target === $elem[0] || event.target.parentElement === $elem[0]) return;
                        scope.hidePopover();
                    });
                }
                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {}
                /**
                 * [appendPopover description] 添加popober
                 * @return {[type]} [description]
                 */
                function appendPopover() {
                    $timeout(function() { //防止页面没渲染完就开始定位位置，而导致的定位偏移
                        // var top = $elem.offset().top + $elem.height() + 10;
                        // var left = $elem.offset().left;
                        var correntLeft = !!$attr["correntLeft"] ? Number($attr["correntLeft"]) : 0;
                        var correntTop =  !!$attr["correntTop"] ? Number($attr["correntTop"]) : 0;
                        $elem.css("position","relative");
                        scope.status.style = {
                            top:$elem.position().top+$elem.height()+5,
                            left: $elem.position().left,
                            "z-index": 1000
                        };
                        var popoverHtml = ["<ul ng-if='status.listShow' class='trsPopover' ng-style='status.style'>",
                            "<li ng-repeat='item in list' ng-bind='item.name' ng-click='chooseItem(item)'></li>",
                            "</ul>"
                        ].join("");
                        popoverHtml = $compile(popoverHtml)(scope);
                        $elem.after(popoverHtml);
                    }, 1500);
                }
                /**
                 * [chooseItem description] 选中项
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                scope.chooseItem = function(item) {
                    $timeout(function() {
                        scope.selectedItem = item;
                        scope.callback();
                    });
                    scope.hidePopover();

                };
                /**
                 * [hidePopover description] 隐藏popover
                 * @return {[type]} [description]
                 */
                scope.hidePopover = function() {
                    $timeout(function() {
                        scope.status.listShow = false;
                    });
                };
            }
        };
    }]);